import { Component, Input, ViewChild, ElementRef, NgZone, ChangeDetectorRef, OnDestroy, HostListener, ViewEncapsulation } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AppService } from '@suite/app.service';

import { GlobalTablesService } from "@common/services/global-tables-service";
import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { CdkOverlayOrigin, ConnectedPosition, FlexibleConnectedPositionStrategyOrigin, ViewportRuler, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { BooleanInput, coerceBooleanProperty, coerceNumberProperty, NumberInput } from '@angular/cdk/coercion';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'st-text-area-overlay',
    templateUrl: './st-text-area-overlay.html',
    styleUrls: ['./st-text-area-overlay.scss'],
    host: {
        class: 'st-text-area-overlay',
    },
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [CdkOverlayOrigin]
})

export class StTextAreaOverlay extends EnpsControl<string> {
    _triggerRect: DOMRect;
    get origin(): CdkOverlayOrigin | FlexibleConnectedPositionStrategyOrigin {
        return this.elmRef;
    }

    get displayValue() {
        return this.value || this.placeholder;
    }

    get connectedPositions(): ConnectedPosition[] {
        return [
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top',
            },
        ];
    }

    @Input() panelClass: string;

    private _minRows: number;
    @Input()
    get minRows(): number {
        return this._minRows;
    }
    set minRows(value: NumberInput) {
        this._minRows = coerceNumberProperty(value);
    }

    private _minHeight: number | string;
    @Input()
    get minHeight(): number | string {
        return this._minHeight;
    }
    set minHeight(value: NumberInput | string) {
        if (typeof value === 'string') {
            this._minHeight = value;
        } else {
            this._minHeight = coerceNumberProperty(value);
        }
    }

    @Input()
    textToHighlight: string;

    private _disableNewLine: boolean;
    @Input()
    get disableNewLine(): boolean {
        return this._disableNewLine;
    }
    set disableNewLine(value: BooleanInput) {
        this._disableNewLine = coerceBooleanProperty(value);
    }

    isPanelOpen: boolean = false;
    tempValue: string;

    @ViewChild('overlay') overlay: CdkConnectedOverlay;


    protected readonly _destroy = new Subject<void>();
    constructor(
        appService: AppService,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        globalTablesService: GlobalTablesService,
        nomWebServicesJson: NomWebServicesJson,
        elementRef: ElementRef,
        protected _viewportRuler: ViewportRuler
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elementRef);
    }

    ngOnInit() {
        // Check rect on resize
        this._viewportRuler
            .change()
            .pipe(takeUntil(this._destroy))
            .subscribe(() => {
                if (this.isPanelOpen) {
                    this._triggerRect = this.elmRef.nativeElement.getBoundingClientRect();
                    this.changeDetectorRef.detectChanges();
                }
            });
    }

    @HostListener('click', ['$event'])
    onContainerClick() {
        this._triggerRect = this.elmRef.nativeElement.getBoundingClientRect();
        this.isPanelOpen = true;
    }


    onTextAreaEnter(event: Event) {
        if (this.disableNewLine) {
            event.preventDefault();
            event.stopPropagation();
        }

    }

    onNgModelChanged(value: string) {
        this.value = value;
    }

    onValueChanged() {
        if(this.disableNewLine) {
            this.value = this.value.replace(/\n|\r/gm, " ");
        }
        this.changed.emit(this.value);
    }

    panelAttached() {
        const textarea = this.overlay?.overlayRef?.overlayElement?.getElementsByTagName('textarea')?.[0];
        this.tempValue = this.value;
        if (textarea instanceof HTMLTextAreaElement) {
            textarea.focus();
        }
    }

    onFocusOut(event) {
        if (!this.elmRef.nativeElement.contains(event.relatedTarget as Element)) {
            this.isPanelOpen = false;
        }
    }

    onOverlayKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.value = this.tempValue;
            this.isPanelOpen = false;
        }
    }
}
